'use client';
import styled from 'styled-components';

import { typography } from '@/styles/helpers';

export const ScBonanzaPromoDashboardContent = styled.div<{
  isLockedPromo: boolean;
}>`
  position: relative;
  width: ${({ isLockedPromo }) => (isLockedPromo ? 'auto' : '80px')};

  .character {
    position: absolute;
    right: -4px;
    top: -5px;
  }

  .progress-bar-line {
    width: 70px;
  }

  .progress-bar-line > .progress-value {
    ${typography['caption1bold']};
  }
`;
